const isObject = (input: unknown): input is Record<string, unknown> => {
  return typeof input === 'object' && input !== null && !Array.isArray(input);
};

const isNull = (input: unknown): input is null => {
  return input === null;
};

export { isObject, isNull };
